import { forwardRef } from "react";
import { Input } from "../../ui/input";

export const TextField = forwardRef(
  (
    {
      item,
      value,
      error,
      helperText,
      disabled,
      autoFocus,
      onChange,
      onBlur,
      className,
    },
    ref
  ) => {
    return (
      <Input
        ref={ref}
        type={
          item.type === "email"
            ? "email"
            : item.type === "password"
            ? "password"
            : "text"
        }
        placeholder={item.placeholder}
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        autoFocus={autoFocus}
        className={`${error ? "border-red-500 hover:border-red-500 focus:border-red-500" : "bg-white border-[#D9D9D9]"} ${
          disabled ? "disabled:text-[#595959]" : ""
        } ${className || ""}`}
        aria-describedby={helperText ? `${item.pathToValue}-error` : undefined}
      />
    );
  }
);

TextField.displayName = "TextField";
